export default __webpack_public_path__ + "static/media/StartExecution.2afeb8e4.svg";